import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/components/system-banners.css';

/** POS installé / build prod : pas de bandeau « pas d'Internet » (fonctionnement 100 % local). */
function isOfflineBannerDisabled() {
  if (typeof window !== 'undefined' && window.electronAPI) return true;
  if (process.env.REACT_APP_HIDE_OFFLINE_BANNER === 'true') return true;
  return false;
}

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { t } = useLanguage();

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOfflineBannerDisabled() || isOnline) return null;

  return (
    <div className="offline-indicator">
      <div className="offline-content">
        <WifiOff size={20} aria-hidden />
        <span>{t('offlineIndicator.message')}</span>
      </div>
    </div>
  );
};

export default OfflineIndicator;
